//componente che racchiude funzioni e html per l'aggiunta di layer da file
import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {addLayerFile} from '../redux';
import { connect } from 'react-redux';
import plusimage from './plus.svg';
import { CheckBox } from '@material-ui/icons';
import { Trans } from 'react-i18next';
//const [checked, setChecked] = React.useState(false);
class CheckBoxAddLayerFile extends React.Component {
    constructor(props) {
        super(props);
        this.state ={
            selectedFile: [],
            checkedArray : [],
            myArray : []
           
        }
        
      }

      
      //carimento del file premendo sul button +
      onChangeHandler=event=>{
        var file = [...event.target.files]
       
       var check = {name:file[0].name,checked:false}
        this.setState(prevState =>({
            myArray: [...prevState.myArray,file[0]],
            checkedArray : [...prevState.checkedArray,check],
            loaded: 0,
          }))
          
          
      }
    
    reset=()=> {
      
      this.props.addLayerFile({file: null,type: null})
    
    }
    
     
    //aggiunta file premendo la checkbox
    handleChange = (event) => {
      event.persist()
      
      var arraycheck = [...this.state.checkedArray]
      
      var check2 = arraycheck.find(x => x.name === event.target.id)
      check2.checked = event.target.checked
      
      this.setState({ checkedArray : arraycheck })
      var FileSelected = this.state.myArray.find(x => x.name === event.target.id)
      try {
        
        
        this.props.addLayerFile({file: FileSelected,type: this.props.typeLayer.type,check:event.target.checked})
      } catch (error) {
        this.props.addLayerFile({file: FileSelected,type: "ShapeFile",check:event.target.checked})
        
      } 
      };
    
      
    
    reset=()=> {
     
      this.props.addLayerFile({file : null,type: null})
      
    }
     handleDragEnter = (event) => {
    
      
      event.preventDefault();
      event.stopPropagation();
      
    };
    
     handleDragOver = (event) => {
      
      event.preventDefault();
      event.stopPropagation();
      event.dataTransfer.dropEffect = 'copy';
      
    };
    handlerDragStart = (event) =>{
      
      event.preventDefault();
      event.stopPropagation();
      
    }
     handleDrop = (event) => {
       
      event.preventDefault();
      event.stopPropagation();
      let files = [...event.dataTransfer.files];
      
      this.setState({
        selectedFile:files[0],
        loaded: 0,
      })
    };
    /* row = () =>{
        return(

        )


    } */
  render(){
    
    
     
    

     const row = (id) => { return<Checkbox 
       id={id}
      size={"small"}  
      onChange={this.handleChange}
      checked={this.state.checkedArray.find(x => x.name === id).checked} 
      color="primary"
      inputProps={{ 'aria-label': 'primary checkbox' }}
      />}
    
        return (
            <div>
            <div onDragStart={this.handlerDragStart}      
            onDrop={this.handleDrop}
            onDragOver={this.handleDragOver}
            onDragEnter={this.handleDragEnter}>
                <label className={"dragDiv"} htmlFor="file-upload" ><Trans>CLICCA QUI PER AGGIUNGERE UN FILE</Trans>
                 <img style={{width: '22px',height: '22px',position: 'relative',left: '20px',top:'8px'}} src={plusimage} alt="plus" ></img></label>
                <input style={{display:'none'}} id="file-upload" type="file" accept=".zip, .kml, .csv, .geojson, .kmz" name="file"  onChange={this.onChangeHandler}/>
            </div>
            <div>
              <table>
                <tbody>
                  {/* <tr>
                    <td className={"fileTesto"}>{console.log(this.state.myArray,"aaaaaaaaaaaaaaa")}{this.state.selectedFile !== null ? this.state.selectedFile.name : null}{row}</td>
                  </tr>
                  <tr>
                    <td>bbbb{row2}</td>
                  </tr> */}
                  {/* { {this.state.myArray.map((x,index)=>row(x !== null ? x.name : console.log(x)))} } */}
                   {this.state.myArray.map((x,index)=>( 
                    
                    x !== null ?  
               <tr  index={index} > 
                {/* <td className={"fileTesto"}>{this.state.selectedFile !== null ? this.state.selectedFile.name : null}</td> */}
                 <td className={"fileTesto"}>{ x.name} {row (x.name)}</td>  
               
             </tr> :console.log(x)))}
            </tbody>
        </table>
            </div>
            </div> 
       )
    }
}

        const mapStateToProps = state => {
            return {
                layerFile: state.layerFile,
                typeLayer: state.typeLayer.typeLayer
            }
          }
          const mapDispatchToProps = dispatch => {
            return {
              addLayerFile: (layerFile) => dispatch(addLayerFile(layerFile))
            }
        }
    
        export default connect(mapStateToProps,mapDispatchToProps)(CheckBoxAddLayerFile)
        
    
        


    

      